import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SpecializationService } from '../services/specialization.service';
import { Specialization } from '../models/specialization.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-specialization-form',
  templateUrl: './specialization-form.component.html'
})
export class SpecializationFormComponent {
  constructor(public service: SpecializationService, private notificationService: NotificationService) { }

  @Input() model: Specialization;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.specializationID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }
}

